/** Alto máximo de la lista desplegable de un autocompletar: no tapa el formulario, hace scroll. */
export const AUTOCOMPLETE_LISTBOX_PROPS = { sx: { maxHeight: 320 } };
